export const primaryColors = {
	primary: '#0093d7',
	secondary: '#aeafb0',
	text: '#191919',
	bg: '#ebeff2',
	theme: '#0093d7',
	white: '#fff',
	black: '#000',
	message: '#9fbe3b',
	danger: '#ff4c23',
};

export const headerColors = {
	headerBg: '#343e48',
	divider: '#b4b4b4',
	leftBar: '#1e2328',
	leftBarText: '#8d8e8f',
	leftBarActive: '#292e33',
	appealDisabled: '#f5f5f5',
};

export const formColors = {
	label: '#b4b4b4',
	borderInput: '#dadada',
	borderInputActive: '#0093d7',
	disable: '#a5a6a7',
	btnPrimary: '#0093d7',
	btnSecondary: '#aeafb0',
	btnPrimaryHover: '#5bc1ff',
	placeholder: '#a4a4a5',
	error: '#c51111',
};

export const navigationColors = {
	navigateActiveTitle: '#0093d7',
	navigateMain: '#aeafb0',
	navigateActive: '#fff',
	navigateDivider: '#4e5256',
	navigateClose: '#8d8e8f',
};

export const gridColors = {
	silver: '#f0f0f0',
	nthLine: '#f6f6f6',
	silverDark: '#e6e6e6',
	blackAbsolute: '#000',
	blue: '#0395d9',
	greyMiddleLight: '#aaa',
	greyMiddleLight2: '#b4b4b4',
	gridNthLine: '#f7f7f7',
	gridIcon: '#a5a6a7',
	gridTh: '#a4a4a5',
	rowText: '#2f3941',
};

export const paginationColors = {
	paginationBorder: '#a4a4a5',
	paginationItem: '#bfbfbf',
	paginationItemDisabled: '#cdd9e7',
	blackInline: '#282828',
	blackInlineDark: '#232323',
};

export const userMenuColors = {
	text: '#393939',
	textHover: '#0093d7',
	role: '#989898',
	divider: '#e6e6e6',
};

export const tabColors = {
	tabBg: '#ebeff2',
	tabActive: '#0093d7',
	bgAvatarCustomer: '#f7d100',
	bgAvatarCompany: '#2cba00',
	tabBorder: '#595959',
	callHover: '#34dd00',
	textColorDark: '#282828',
	textColorLight: '#9c9c9c',
	tabHeaderBg: '#f8f8f8',
};

export const searchColors = {
	borderGray: '#3e3e3e',
	colorName: '#262626',
	colorAddr: '#acadae',
};

export const avatarColors = {
	bg: '#cacaca',
};

export const statusColors = {
	inProgress: '#de4d2a',
	created: '#f7d100',
	pause: '#8141b2',
	solved: '#6eb92b',
	checked: '#c8f6a0',
	wait: '#0093d7',
	completed: '#5291d3',
	beingCreated: '#dcdcdc',
	wasSent: '#00f6ff',
	continued: '#7343ad',
};

export const buttonColors = {
	primary: '#0065c1',
	primaryHover: '#0058a8',
	secondary: '#929598',
	secondaryHover: '#636363',
};

export const fonts = {
	text: '\'Sfui\', Arial, sans-serif',
	textBold: '\'SFUIText-Bold\', Arial, sans-serif',
	textSemibold: '\'Sfui semibold\', Arial, sans-serif',
	textLight: '\'SFUITextLight\', Arial, sans-serif',
	textHeavy: '\'Sfui heavy\', Arial, sans-serif',
	textMedium: '\'SFUIText-Medium\', Arial, sans-serif',
};

export const scales = {
	home110x110: 1.029,
	home244x244: 1.031,
	home110x244: 1.027,
	home244x110: 1.028,
};

export const breakpoints = {
	huge: '1500px',
	big: '1200px',
	medium: '990px',
	small: '590px',
};

export const timing = {
	notificationPopupEasing: 'cubic-bezier(0.64, 0.57, 0.67, 1.53)',
};

export const dimensions = {
	widthNavPanel: '65px',
	widthNavPanelWide: '175px',
	mainPadding: '110px', // 175px - 65px
};
